import { Button, Grid } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { trackMission } from '../../../Api/suiviMission/missions';

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

export default function MissionSearchInput({ untrackedMissions, openCloseAddMission }) {

    MissionSearchInput.propTypes = {
        untrackedMissions: PropTypes.any,
        openCloseAddMission: PropTypes.func,
    };

    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;
    const { i18n } = useTranslation();
    React.useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }

        (async () => {
            await sleep(1e3); // For demo purposes.

            if (active) {
                setOptions([...untrackedMissions]);
            }
        })();

        return () => {
            active = false;
        };
    }, [loading]);

    React.useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);
    const [newMission, setNewMission] = React.useState();
    const handleAddMission = () => {
        if (newMission) {
            //api call
            newMission.tracked = true;
            trackMission(newMission);
            console.log(newMission);
        }
        openCloseAddMission();
    };
    return (
        <Grid
            container
            alignItems="end"
            sx={{ marginBottom: '6px' }}
        >
            <Grid
                item
                xs={10}
            >
                <Autocomplete
                    id="MissionSearchInput-demo"
                    sx={{ width: '100%' }}
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    isOptionEqualToValue={(option, value) => option?.titre === value?.titre}
                    getOptionLabel={(option) => option?.titre}
                    options={untrackedMissions}
                    loading={loading}
                    onChange={(event, value) => {
                        setNewMission(value);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={i18n.t('Titre de la mission')}
                            variant="standard"
                            value={newMission}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {loading ? (
                                            <CircularProgress
                                                color="inherit"
                                                size={20}
                                            />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />
                    )}
                />
            </Grid>
            <Grid
                item
                xs={2}
            >
                <Button
                    onClick={handleAddMission}
                >
                    {i18n.t('Ajouter')}
                </Button>
            </Grid>
        </Grid>
    );
}
